import { ButtonBase, Dialog, IconButton } from "@mui/material";
import { Flex } from "@zfp-akademie-a-s/zfp-design";
import { CloseIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { ZoomInIcon } from "Components/_Shared/Icons/Icons";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useState } from "react";

type Props = {
  readonly src: string;
  readonly alt: string;
  readonly maxThumbnailWidth?: number;
};

export const ClickableImage = ({ src, alt, maxThumbnailWidth = 240 }: Props) => {
  const { t } = useResource();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonBase
        onClick={() => setIsOpen(true)}
        aria-label={t(Resources.Common.EnlargeImage)}
        sx={{
          position: "relative",
          display: "block",
          maxWidth: maxThumbnailWidth,
          borderRadius: Radius.M,
          overflow: "hidden",
          border: "1px solid",
          borderColor: "divider",
          "&:hover .lightbox-overlay": { opacity: 1 },
        }}
      >
        <img src={src} alt={alt} style={{ display: "block", width: "100%", height: "auto" }} />
        <Flex
          className="lightbox-overlay"
          alignItems="center"
          justifyContent="center"
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.35)",
            opacity: 0,
            transition: "opacity 0.15s ease",
          }}
        >
          <ZoomInIcon sx={{ color: "common.white" }} />
        </Flex>
      </ButtonBase>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="lg">
        <Flex justifyContent="flex-end" sx={{ position: "absolute", top: Spacing.S, right: Spacing.S, zIndex: 1 }}>
          <IconButton
            onClick={() => setIsOpen(false)}
            aria-label={t(Resources.Common.Close)}
            sx={{ backgroundColor: "rgba(255, 255, 255, 0.85)" }}
          >
            <CloseIcon />
          </IconButton>
        </Flex>
        <img src={src} alt={alt} style={{ display: "block", maxWidth: "100%", maxHeight: "85vh" }} />
      </Dialog>
    </>
  );
};
